import React from 'react';

/**
 * BlurOverlay — Activated on focus loss to obscure video content.
 *
 * Renders a full-viewport overlay with:
 * - backdrop-filter: blur(20px) to blur the underlying video
 * - Centered association logo so capture tools get blurred content + logo
 *
 * Validates: Req 1.31
 */
interface BlurOverlayProps {
  /** Whether the overlay is active (focus lost) */
  active: boolean;
  /** URL of the association logo to display centered */
  logoUrl: string;
}

export const BlurOverlay: React.FC<BlurOverlayProps> = ({ active, logoUrl }) => {
  if (!active) return null;

  return (
    <div style={styles.overlay} data-testid="blur-overlay">
      <img
        src={logoUrl}
        alt="Association logo"
        style={styles.logo}
      />
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 50,
  },
  logo: {
    maxWidth: '40%',
    maxHeight: '40%',
    objectFit: 'contain',
  },
};
